// removed by extract-text-webpack-plugin
module.exports = {"orderSummaryTile":"_3-hZf","upperSection":"_3bzL8","detailsBlock":"eryOn","totalBlock":"_10Q_f","storeName":"_2aN6g","orderDetails":"tp4Y4","orderState":"_1bD9K","active":"_3IdUs","inactive":"_2OZsW","total":"_3uUtV","receiptLink":"_1UOat","receiptLinkWrapper":"PX5dZ"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/OrderSummaryTile/index.sass
// module id = 1492
// module chunks = 1